const { createSelector } = require('reselect')

// For Admin Panel
const selectFileAdmin = state => state.fileDomain.getFileAdmin
const getFileAdmin = () => createSelector(
  [selectFileAdmin],
  cse => cse.data,
)
const getFileAdminError = () => createSelector(
  [selectFileAdmin],
  cse => cse.error,
)
const getFileAdminLoading = () => createSelector(
  [selectFileAdmin],
  cse => cse.loading,
)

// For Admin Panel - Getting file and pushing into array
const selectFileAndAppendAdmin = state => state.fileDomain.getFileAndAppendAdmin
const getFileAndAppendAdmin = () => createSelector(
  [selectFileAndAppendAdmin],
  cse => cse.data,
)
const getFileAndAppendAdminError = () => createSelector(
  [selectFileAndAppendAdmin],
  cse => cse.error,
)
const getFileAndAppendAdminLoading = () => createSelector(
  [selectFileAndAppendAdmin],
  cse => cse.loading,
)

const selectFileAndAppendUser = state => state.fileDomain.getFileAndAppendUser
const getFileAndAppendUser = () => createSelector(
  [selectFileAndAppendUser],
  cse => cse.data,
)
const getFileAndAppendUserError = () => createSelector(
  [selectFileAndAppendUser],
  cse => cse.error,
)
const getFileAndAppendUserLoading = () => createSelector(
  [selectFileAndAppendUser],
  cse => cse.loading,
)

// For Admin Panel
const selectUploadFilesAdmin = state => state.fileDomain.uploadFilesAdmin
const uploadFilesAdmin = () => createSelector(
  [selectUploadFilesAdmin],
  cse => cse.data,
)
const uploadFilesAdminError = () => createSelector(
  [selectUploadFilesAdmin],
  cse => cse.error,
)
const uploadFilesAdminLoading = () => createSelector(
  [selectUploadFilesAdmin],
  cse => cse.loading,
)

// For Admin Panel
const selectGetUploadFilesUrlAdmin = state => state.fileDomain.getUploadFilesUrlStateAdmin
const getUploadFilesUrlAdmin = () => createSelector(
  [selectGetUploadFilesUrlAdmin],
  cse => cse.data,
)
const getUploadFilesUrlAdminError = () => createSelector(
  [selectGetUploadFilesUrlAdmin],
  cse => cse.error,
)
const getUploadFilesUrlAdminLoading = () => createSelector(
  [selectGetUploadFilesUrlAdmin],
  cse => cse.loading,
)

const selectFile = state => state.fileDomain.getFile
const getFile = () => createSelector(
  [selectFile],
  cse => cse.data,
)
const getFileError = () => createSelector(
  [selectFile],
  cse => cse.error,
)
const getFileLoading = () => createSelector(
  [selectFile],
  cse => cse.loading,
)

// Use-case -> when needs to get file on multiple places in same component
const selectFileTwo = state => state.fileDomain.getFileTwo
const getFileTwo = () => createSelector(
  [selectFileTwo],
  cse => cse.data,
)
const getFileTwoError = () => createSelector(
  [selectFileTwo],
  cse => cse.error,
)
const getFileTwoLoading = () => createSelector(
  [selectFileTwo],
  cse => cse.loading,
)

const selectMultipleFile = state => state.fileDomain.getMultipleFile
const getMultipleFile = () => createSelector(
  [selectMultipleFile],
  cse => cse.data,
)
const getMultipleFileError = () => createSelector(
  [selectMultipleFile],
  cse => cse.error,
)
const getMultipleFileLoading = () => createSelector(
  [selectMultipleFile],
  cse => cse.loading,
)

const selectUploadFiles = state => state.fileDomain.uploadFiles
const uploadFiles = () => createSelector(
  [selectUploadFiles],
  cse => cse.data,
)
const uploadFilesError = () => createSelector(
  [selectUploadFiles],
  cse => cse.error,
)
const uploadFilesLoading = () => createSelector(
  [selectUploadFiles],
  cse => cse.loading,
)

const selectGetUploadFilesUrl = state => state.fileDomain.getUploadFilesUrlState
const getUploadFilesUrl = () => createSelector(
  [selectGetUploadFilesUrl],
  cse => cse.data,
)
const getUploadFilesUrlError = () => createSelector(
  [selectGetUploadFilesUrl],
  cse => cse.error,
)
const getUploadFilesUrlLoading = () => createSelector(
  [selectGetUploadFilesUrl],
  cse => cse.loading,
)

const selectGetReferralFileState = state => state.fileDomain.getReferralFileState
const getReferralFile = () => createSelector(
  [selectGetReferralFileState],
  cse => cse.data,
)
const getReferralFileError = () => createSelector(
  [selectGetReferralFileState],
  cse => cse.error,
)
const getReferralFileLoading = () => createSelector(
  [selectGetReferralFileState],
  cse => cse.loading,
)

const selectGetMCFileState = state => state.fileDomain.getMCFileState
const getMCFile = () => createSelector(
  [selectGetMCFileState],
  cse => cse.data,
)
const getMCFileError = () => createSelector(
  [selectGetMCFileState],
  cse => cse.error,
)
const getMCFileLoading = () => createSelector(
  [selectGetMCFileState],
  cse => cse.loading,
)

const selectGetPrescriptionFileState = state => state.fileDomain.getPrescriptionFileState
const getPrescriptionFile = () => createSelector(
  [selectGetPrescriptionFileState],
  cse => cse.data,
)
const getPrescriptionFileError = () => createSelector(
  [selectGetPrescriptionFileState],
  cse => cse.error,
)
const getPrescriptionFileLoading = () => createSelector(
  [selectGetPrescriptionFileState],
  cse => cse.loading,
)

module.exports = {
  // For Admin Panel
  getFileAdmin,
  getFileAdminError,
  getFileAdminLoading,

  // For Admin Panel - Getting file and pushing into array
  getFileAndAppendAdmin,
  getFileAndAppendAdminError,
  getFileAndAppendAdminLoading,

  // For Users - Getting file and pushing into array
  getFileAndAppendUser,
  getFileAndAppendUserError,
  getFileAndAppendUserLoading,

  // For Admin Panel
  uploadFilesAdmin,
  uploadFilesAdminError,
  uploadFilesAdminLoading,

  // For Admin Panel
  getUploadFilesUrlAdmin,
  getUploadFilesUrlAdminError,
  getUploadFilesUrlAdminLoading,

  getFile,
  getFileError,
  getFileLoading,

  // Use-case -> when needs to get file on multiple places in same component
  getFileTwo,
  getFileTwoError,
  getFileTwoLoading,

  getMultipleFile,
  getMultipleFileError,
  getMultipleFileLoading,

  uploadFiles,
  uploadFilesError,
  uploadFilesLoading,
  getUploadFilesUrl,
  getUploadFilesUrlError,
  getUploadFilesUrlLoading,

  getReferralFile,
  getReferralFileError,
  getReferralFileLoading,
  getMCFile,
  getMCFileError,
  getMCFileLoading,
  getPrescriptionFile,
  getPrescriptionFileError,
  getPrescriptionFileLoading,
}
